import axios from "axios";

/** Shared axios instance for all API calls, scoped to this origin's `/api` base path. */
const apiClient = axios.create({
  baseURL: `${window.location.origin}/api`,
});

export default apiClient;
